import React, { useState, useEffect } from 'react';
import './style.css';
import { Link } from 'react-router-dom';
import video from './motocycles.mp4';


const TiendaOnline = () => {
  const [randomColors, setRandomColors] = useState([]);

  useEffect(() => {
    generateRandomColors();
  }, []);

  const generateRandomColors = () => {
    const colors = [];
    const numberOfColors = 16; // Puedes ajustar la cantidad de colores aquí

    for (let i = 0; i < numberOfColors; i++) {
      const randomColor = getRandomColor();
      colors.push(randomColor);
    }

    setRandomColors(colors);
  };

  const getRandomColor = () => {
    const letters = '0123456789ABCDEF';
    let color = '#';

    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }

    return color;
  };

  return (
    <div>
      <div className='vid'>
        <video loop autoPlay>
          <source src={video} type='video/mp4' />
        </video>

      </div>
      <div className='containerButton'>
        <Link className='buttonStyle' to='/'>
          <button>Regresar al inicio</button>
        </Link>
      </div>
      <div className='paintSection'>
        <h2>Tipos de Pinturas de Automotriz</h2>
        <p>
          En nuestra tienda, ofrecemos una amplia variedad de pinturas de automotriz para
          personalizar y proteger tu motocicleta. Algunos de los tipos de pinturas que
          ofrecemos son:
        </p>
        <ul>
          <Link className='link' to='https://api.whatsapp.com/send?phone=584245048417&text=Hola%2C%20vengo%20de%20la%20secci%C3%B3n%20de%20pinturas%20acriquilas%20que%20esta%20en%20su%20tienda%20online%2C%20quisiera%20saber%20mas%20informacion'><li>Pintura acrílica</li></Link>
          <Link className='link' to='https://api.whatsapp.com/send?phone=584245048417&text=Hola%2C%20vengo%20de%20la%20secci%C3%B3n%20de%20pinturas%20al%20%C3%B3leo%20que%20esta%20en%20su%20tienda%20online%2C%20quisiera%20saber%20mas%20informacion'> <li>Pintura al óleo</li> </Link>
          <Link className='link' to='https://api.whatsapp.com/send?phone=584245048417&text=Hola%2C%20vengo%20de%20la%20secci%C3%B3n%20de%20pinturas%20metalizada%20que%20esta%20en%20su%20tienda%20online%2C%20quisiera%20saber%20mas%20informacion' ><li>Pintura metalizada</li></Link>
          <Link className='link' to='https://api.whatsapp.com/send?phone=584245048417&text=Hola%2C%20vengo%20de%20la%20secci%C3%B3n%20de%20Pintura%20perlada%20que%20esta%20en%20su%20tienda%20online%2C%20quisiera%20saber%20mas%20informacion'><li>Pintura perlada</li></Link>
          <Link className='link' to='https://api.whatsapp.com/send?phone=584245048417&text=Hola%2C%20vengo%20de%20la%20secci%C3%B3n%20de%20Pintura%20mate%2C%20que%20esta%20en%20su%20tienda%20online%2C%20quisiera%20saber%20mas%20informacion'><li>Pintura mate</li></Link>
          <Link className='link' to='https://api.whatsapp.com/send?phone=584245048417&text=Hola%2C%20vengo%20de%20la%20secci%C3%B3n%20de%20Pintura%20fluorescente%20que%20esta%20en%20su%20tienda%20online%2C%20quisiera%20saber%20mas%20informacion'><li>Pintura fluorescente</li></Link>
        </ul>
      </div>
      <div className='colorTable'>
        <table>
          <tbody>
            <tr>
              {randomColors.map((color, index) => (
                <td key={index} style={{ backgroundColor: color, width: '26px', height: '26px' }}></td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  );
};

export default TiendaOnline;
